<section
  class="flex h-full w-full flex-col overflow-hidden bg-white text-gray-900"
  role="dialog"
  [attr.aria-label]="'board_v3_calls_transcription' | translate"
>
  <header class="flex shrink-0 items-center gap-3 border-b border-gray-100 px-4 py-3">
    <div class="flex h-10 w-10 shrink-0 items-center justify-center rounded-lg bg-orange-50 text-orange-600">
      <app-icon>forum</app-icon>
    </div>
    <div class="min-w-0 flex-1">
      <h2 class="m-0 text-base font-bold leading-6 text-gray-900">{{ 'board_v3_calls_transcription' | translate }}</h2>
      @if (call?.phone) {
        <p class="m-0 truncate text-sm leading-5 text-gray-500">{{ call?.phone }}</p>
      }
    </div>
    <button
      type="button"
      class="flex h-9 w-9 shrink-0 items-center justify-center rounded-lg text-gray-500 hover:bg-gray-100"
      [attr.aria-label]="'close' | translate"
      (click)="onCancel()"
    >
      <app-icon>close</app-icon>
    </button>
  </header>

  <div class="crm-scroll min-h-0 flex-1 overflow-y-auto bg-gray-50 px-4 py-4">
    @if (loading) {
      <div class="flex flex-col gap-2">
        <div class="ml-auto h-10 w-2/3 animate-pulse rounded-2xl bg-white"></div>
        <div class="h-10 w-2/3 animate-pulse rounded-2xl bg-white"></div>
        <div class="ml-auto h-10 w-1/2 animate-pulse rounded-2xl bg-white"></div>
      </div>
    } @else if (utterances.length) {
      <div class="flex flex-col gap-2">
        @for (utterance of utterances; track $index) {
          <div class="flex" [class.justify-end]="isOwnMessage(utterance.speaker)">
            <div
              class="max-w-[80%] rounded-2xl px-3.5 py-2 text-sm leading-5 shadow-sm"
              [class.bg-orange-500]="isOwnMessage(utterance.speaker)"
              [class.text-white]="isOwnMessage(utterance.speaker)"
              [class.rounded-br-sm]="isOwnMessage(utterance.speaker)"
              [class.bg-white]="!isOwnMessage(utterance.speaker)"
              [class.text-gray-800]="!isOwnMessage(utterance.speaker)"
              [class.rounded-bl-sm]="!isOwnMessage(utterance.speaker)"
            >
              <p class="m-0 whitespace-pre-wrap">{{ utterance.text }}</p>
              <span
                class="mt-1 block text-right text-[11px] leading-none opacity-70"
              >
                {{ formatTimestamp(utterance.start) }}
              </span>
            </div>
          </div>
        }
      </div>
    } @else {
      <div class="flex h-full min-h-48 flex-col items-center justify-center rounded-xl bg-white px-4 py-8 text-center">
        <app-icon class="mb-2 !text-[28px] text-gray-300">forum</app-icon>
        <p class="m-0 text-sm font-medium text-gray-600">{{ 'board_v3_calls_transcript_empty' | translate }}</p>
      </div>
    }
  </div>
</section>
